import {
  GET_NEWS_MODAL_FAILURE,
  GET_NEWS_MODAL_REQUEST,
  GET_NEWS_MODAL_SUCCESS,
} from '../../../actions'
import { IDLE, FETCHED, FETCHING, FAILED } from '../../../constants/fetchStates'

const initial = {
  data: {},
  status: IDLE
}

const modal = (state = initial, action) => {
  switch (action.type) {
    case GET_NEWS_MODAL_REQUEST:
      return {
        ...state,
        status: FETCHING
      }
    case GET_NEWS_MODAL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: FETCHED
      }
    case GET_NEWS_MODAL_FAILURE:
      return {
        ...state,
        status: FAILED
      }
    default:
      return state
  }
}

export default modal
